/* global fbq, pintrk, ttq */
import { EVENTS } from '@campsite-bio/component-lib';

import { getSessionId } from '@/utils/session';

function getDefaultTrackingParams(route) {
  const { query } = route;
  let referrer = document.referrer;
  if (query.qrcode && !referrer) {
    referrer = `?qr_code=${query.qrcode}`;
  }

  return {
    referrer,
    epoch: Date.now(),
    session_id: getSessionId(),
    query: Object.assign({}, query),
  };
}

function sendTracking(url, params) {
  if (navigator.sendBeacon) {
    navigator.sendBeacon(url, JSON.stringify(params));
  } else {
    const request = new XMLHttpRequest();
    request.open('POST', url, true);
    request.send(JSON.stringify(params));
  }
}

export default ({ $config, route }, inject) => {
  function track(data, extras) {
    const params = {
      ...getDefaultTrackingParams(route),
      ...data,
    };

    sendTracking($config.linkClickEndpoint, params);

    // track facebook lead
    if (window.fbq) {
      fbq('trackCustom', 'linkClick', { url: extras.href, label: extras.text });
    }
    // track pinterest lead
    if (window.pintrk) {
      pintrk('track', 'lead', {
        lead_type: 'Clicked Link',
      });
    }
    // track tiktok lead
    if (window.ttq) {
      ttq.track('ClickButton');
    }
  }

  function trackPageView(data) {
    const params = {
      ...getDefaultTrackingParams(route),
      ...data,
    };

    sendTracking($config.pageViewEndpoint, params);
  }

  function trackEvent(events, data) {
    const params = {
      events,
      ...getDefaultTrackingParams(route),
      ...data,
    };

    if (
      events.some(
        (e) =>
          e.event_name === EVENTS.EMAIL_OPT_IN ||
          e.event_name === EVENTS.SMS_OPT_IN,
      )
    ) {
      // track facebook lead
      if (window.fbq) {
        fbq('track', 'Lead');
      }
      // track pinterest lead
      if (window.pintrk) {
        pintrk('track', 'lead', {
          lead_type: 'Opt-in form',
        });
      }
      // track tiktok lead
      if (window.ttq) {
        ttq.track('SubmitForm');
      }
    }

    sendTracking($config.eventEndpoint, params);
  }

  inject('track', track);
  inject('trackPageView', trackPageView);
  inject('trackEvent', trackEvent);
};
